module.exports = __webpack_public_path__ + "img/filtro.f034d84d.svg";